import { render, staticRenderFns } from "./old-member.vue?vue&type=template&id=34c542e7&scoped=true&"
import script from "./old-member.vue?vue&type=script&lang=js&"
export * from "./old-member.vue?vue&type=script&lang=js&"
import style0 from "./old-member.vue?vue&type=style&index=0&id=34c542e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c542e7",
  null
  
)

export default component.exports